import React, { useState, useEffect } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Checkbox,
	FormControlLabel
} from "@mui/material";
import { NavLink } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
// import { AiOutlineSearch } from "react-icons/ai";
import SearchIcon from "@mui/icons-material/Search";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import { adminKycMappingList } from "../../redux/actions/adminKycMappingListAction";
import { adminAddOrUpdateKycMapping } from "../../redux/actions/adminAddOrUpdateKycMappingAction";
import Util from "../../validation";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import { getWalletOwnerIdAndNameList } from "../../redux/actions/getWalletOwnerIdAndNameListAction";
import val from "../../getThemeDetails"

const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

function AdminKycMapping() {
	const [searchPartnerId, setSearchPartnerId] = useState("");

	const [page, setPage] = useState(0);
	const [editOpen, setEditOpen] = React.useState(false);
	const [viewOpen, setViewOpen] = React.useState(false);
	const [addOpen, setAddOpen] = React.useState(false);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [isLoading, setIsLoading] = useState(false);

	const [addOrUpdateKycMappingStatus, setAddOrUpdateKycMappingStatus] =
		useState(false);
	const [addOrUpdateKycMappingArray, setAddOrUpdateKycMappingArray] = useState(
		[]
	);
	const [getWalletOwnerIdResArray, setGetWalletOwnerIdResArray] = useState([]);

	const [getKycMappingStatus, setGetKycMappingStatus] = useState(false);
	const [getKycMappingArray, setGetKycMappingArray] = useState([]);

	const [notificationOpen, setNotificationOpen] = React.useState(false);
	const [getWalletOwnerIdStatus, setGetWalletOwnerIdStatus] = useState(false);

	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;
	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	var authToken = regenerateTokenRes.data.AuthToken;
	const classes = useStyles();
	const dispatch = useDispatch();

	const [user, setUser] = useState({
		partnerId: "",
		kycPartnerId: "",
		username: "",
		key: "",
		hostURL: "",
		kycId: ""
	});

	const { partnerId, kycPartnerId, username, key, hostURL, kycId } = user;

	const onInputChange = ({ target: { name, value } }, type) => {
		// setUser({ ...user, [e.target.name]: e.target.value });
		const obj = {
			...user
		};

		if (type == "number") {
			obj[name] = Util.verifyMobile(value) ? value : obj[name];
		} else if (type == "alphabet") {
			obj[name] = Util.verifyAlphabet(value) ? value : obj[name];
		} else if (type == "both") {
			obj[name] = Util.alphaNumeric(value) ? value : obj[name];
		} else {
			// obj[name] = value.trim()
			obj[name] = Util.noWhiteSpace(value) ? value : obj[name];
		}
		setUser(obj);
	};

	const getWalletOwnerIdRes = useSelector(
		({ getWalletOwnerIdAndNameList }) => getWalletOwnerIdAndNameList
	);
	const getKycMappingRes = useSelector(
		({ adminKycMappingList }) => adminKycMappingList
	);

	const addOrUpdateKycMappingRes = useSelector(
		({ adminAddOrUpdateKycMapping }) => adminAddOrUpdateKycMapping
	);

	const handleNoticationClose = () => {
		setNotificationOpen(false);
	};



	const handleChange = ({ target: { name, value } }) => {
		// if (name === "searchPartnerId") {
		// 	// (value);setSearchPartnerId
		// 	Util.verifyNumber(value)
		// 		? setSearchPartnerId(value)
		// 		: setSearchPartnerId(searchPartnerId);
		// }
		if (name === 'searchPartnerId') {
			setSearchPartnerId(value);

		}

	};

	const getKycMappingListReq = () => {
		setIsLoading(true);
		setGetKycMappingStatus(true);
		let req = {
			walletOwnerId: searchPartnerId,
			adminId: val.adminIDS

			// adminId: 2
		};
		dispatch(adminKycMappingList(req, authToken));
	};

	const getKycMappingFunc = () => {
		if (getKycMappingStatus) {
			if (getKycMappingRes.data.status == "success") {
				setGetKycMappingArray([].concat(getKycMappingRes.data.kycMappingList));
				setIsLoading(false);
			}
			if (getKycMappingRes.data.status == "failed") {
				setGetKycMappingArray(getKycMappingRes.data);
				setIsLoading(false);
				NotificationPopups(
					"error",
					"Failed",
					getKycMappingRes.data.description
				);
				if (
					getKycMappingRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getKycMappingRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getKycMappingRes.data.status == "INVALID REQUEST") {
				setGetKycMappingArray(getKycMappingRes.data);
				setIsLoading(false);
				NotificationPopups(
					"error",
					"Failed",
					getKycMappingRes.data.description
				);
			}
			if (getKycMappingRes.data.status == "NOT FOUND") {
				setGetKycMappingArray(getKycMappingRes.data);
				setIsLoading(false);
				NotificationPopups(
					"error",
					"Failed",
					getKycMappingRes.data.status
				);

			}
		}
	};


	useEffect(() => {
		getKycMappingFunc();
	}, [getKycMappingRes.data.status]);
	// useEffect(() => {
	// 	if (regenerateTokenRes.data.status == "success") {
	// 		getKycMappingListReq()
	// 	}
	//   }, [regenerateTokenRes.data.AuthToken]);
	useEffect(() => {
		if (regenerateTokenRes.data.status == "success" && searchPartnerId) {
			console.log("Calling API")
			getKycMappingListReq();
		}
	}, [regenerateTokenRes.data.AuthToken]);

	const addOrUpdateKycMappingReq = () => {
		console.log("PARTNERIDDDDD", partnerId)
		setAddOrUpdateKycMappingStatus(true);
		let req = {
			partnerId: partnerId == "Select Owner Id" ? "" : partnerId.split("-")[0],
			kycPartnerId: kycPartnerId,
			username: username,
			key: key,
			hostUrl: hostURL,
			kycId: kycId
		};
		dispatch(adminAddOrUpdateKycMapping(req, authToken));

	};

	const addOrUpdateKycMappingFunc = () => {
		if (addOrUpdateKycMappingStatus) {
			if (addOrUpdateKycMappingRes.data.status == "success") {
				setAddOrUpdateKycMappingArray(addOrUpdateKycMappingRes.data);
				setEditOpen(false);
				setAddOpen(false);
				setNotificationOpen(true);
			}
			if (addOrUpdateKycMappingRes.data.status == "failed") {
				setAddOrUpdateKycMappingArray(addOrUpdateKycMappingRes.data);
				setEditOpen(false);
				setAddOpen(false);
				setNotificationOpen(true);
				if (
					addOrUpdateKycMappingRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					addOrUpdateKycMappingRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (addOrUpdateKycMappingRes.data.status == "INVALID REQUEST") {
				setAddOrUpdateKycMappingArray(addOrUpdateKycMappingRes.data);
				setEditOpen(false);
				setAddOpen(false);
				setNotificationOpen(true);
			}
			if (addOrUpdateKycMappingRes.data.status == "NOT FOUND") {
				setAddOrUpdateKycMappingArray(addOrUpdateKycMappingRes.data);
				setEditOpen(false);
				setAddOpen(false);
				setNotificationOpen(true);
			}
		}
	};

	useEffect(() => {
		addOrUpdateKycMappingFunc();
	}, [addOrUpdateKycMappingRes.data.status]);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleClose = () => {
		setEditOpen(false);
		setViewOpen(false);
		setAddOpen(false);
		setUser({
			partnerId: "",
			kycPartnerId: "",
			username: "",
			key: "",
			hostURL: "",
			kycId: ""
		});
	};

	const addProofType = () => {
		setAddOpen(true);
	};

	const getWalletOwnerIdStatusFunc = () => {
		if (getWalletOwnerIdStatus) {
			console.log("Lcs", getWalletOwnerIdRes)
			if (getWalletOwnerIdRes.data.status == "success") {
				console.log("Lcssss", getWalletOwnerIdRes)

				setGetWalletOwnerIdResArray(
					[].concat(getWalletOwnerIdRes.data.ownerList)
				);
			}
			if (getWalletOwnerIdRes.data.status == "failed") {
				setGetWalletOwnerIdResArray(getWalletOwnerIdRes.data);
				if (
					getWalletOwnerIdRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getWalletOwnerIdRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId || localStorage.getItem("walletOwnerId"));
				}
			}
			if (getWalletOwnerIdRes.data.status == "NOT FOUND") {
				setGetWalletOwnerIdResArray(getWalletOwnerIdRes.data);
				if (
					getWalletOwnerIdRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getWalletOwnerIdRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	const getWalletOwnerIdAndNameListReq = () => {
		setGetWalletOwnerIdStatus(true);
		dispatch(
			getWalletOwnerIdAndNameList(
				{
					loginDetails: {
						adminId: val.adminIDS

						// adminId: "2"
					}
				},
				authToken
			)
		);
	};
	useEffect(() => {
		// if (regenerateTokenRes.data.status == "success") {

		getWalletOwnerIdAndNameListReq();
		// }
	}, []);
	useEffect(() => {
		console.log("made get req");
		getWalletOwnerIdStatusFunc();
	}, [getWalletOwnerIdRes]);

	return (
		<>
			<Layout>
				<Card>
					<Grid
						container
						style={{
							padding: "10px",
							marginTop: "1rem",
							marginLeft: "1rem",
							textAlign: "center"
						}}
					>
						<Grid item md={4} sm={12} lg={9}></Grid>
						<Grid item md={4} sm={12} lg={3}>
							{/* <Button
								variant="contained"
								style={{ backgroundColor: "#00b9f5", color: "white" }}
								size="small"
								onClick={() => addProofType()}
							>
								Add New Proof Type
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={() => addProofType()}
							>
								Add New Proof Type
							</CustomButton>
						</Grid>
					</Grid>

					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						{/* <Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								size="small"
								color="primary"
								type="text"
								variant="standard"
								label="Partner Id"
								fullWidth={true}
								name="searchPartnerId"
								value={searchPartnerId || ""}
								onChange={handleChange}
							></TextField>
						</Grid> */}
						<Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								required
								margin="dense"
								variant="standard"

								select
								style={{ marginTop: "3px" }}

								color="primary"
								type="text"
								label="Partner ID"
								fullWidth
								name="searchPartnerId"
								// value={walletOwnerId}
								defaultValue={searchPartnerId || "Select Owner Id"}
								onChange={handleChange}

							>
								<MenuItem value="Select Owner Id" selected="Select Owner Id">
									Select Owner Id
								</MenuItem>
								{console.log("GETARRAYowner", getWalletOwnerIdResArray)}
								{getWalletOwnerIdResArray.status !== "failed" && getWalletOwnerIdRes.data.ownerList &&
									getWalletOwnerIdResArray.map((x) => (
										<MenuItem value={x.split("-")[0]}>{x}</MenuItem>
									))}
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={4} lg={4}>
							<CustomButton
								style={{
									padding: "8px"
								}}
								// endIcon={<AiOutlineSearch />}
								variant="contained"
								onClick={getKycMappingListReq}
							>
								Search<SearchIcon />
							</CustomButton>
							{/* <Button
								style={{
									backgroundColor: "#00b9f5",
									color: "white",
									marginTop: "9px"
								}}
								endIcon={<AiOutlineSearch />}
								variant="contained"
								onClick={getKycMappingListReq}
							>
								Search
							</Button> */}
						</Grid>
					</Grid>
				</Card>

				{isLoading ? (
					<LoadingSpinner />
				) : getKycMappingArray.length == undefined ||
					getKycMappingArray.status == "NOT FOUND" ||
					getKycMappingArray.status == "INVALID REQUEST" ||
					!getKycMappingStatus ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography variant="body1" style={{ fontWeight: "700" }}
									className="themeText"

								>
									Report Table
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									variant="secondary"
								// style={{ backgroundColor: "#00b9f5", color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography variant="body1" style={{ fontWeight: "700" }}
									className="themeText"

								>
									Report Table
								</Typography>
							</Grid>
							<TableContainer component={Paper} className="text-nowrap my-3">
								<Table
									className={classes.table}
									size="small"
									aria-label="a dense table"
								>
									<TableHead>
										<TableRow className="tableHeaderColor">
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Partner Id
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Username
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Kyc Id
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Kyc Partner Id
											</TableCell>
										</TableRow>
									</TableHead>

									<TableBody>
										{getKycMappingArray &&
											[]
												.concat(getKycMappingArray)
												.slice(
													page * rowsPerPage,
													page * rowsPerPage + rowsPerPage
												)
												.map((row, index) => (
													<TableRow>
														<TableCell align="center">
															{row.partnerId}
														</TableCell>
														<TableCell align="center">{row.username}</TableCell>
														<TableCell align="center">{row.kycId}</TableCell>
														<TableCell align="center">
															{row.kycPartnerId}
														</TableCell>
													</TableRow>
												))}
									</TableBody>
								</Table>
								<TablePagination
									rowsPerPageOptions={[5, 10, 25]}
									component="div"
									count={getKycMappingArray.length}
									rowsPerPage={rowsPerPage}
									page={page}
									onPageChange={handleChangePage}
									onRowsPerPageChange={handleChangeRowsPerPage}
								/>
							</TableContainer>
						</Grid>
					</Card>
				)}

				<div>
					<Dialog open={addOpen} onClose={handleClose}>
						<DialogTitle style={{ minWidth: "600px" }}>
							Add KYC Mapping
						</DialogTitle>
						<DialogContent>
							{/* <TextField
								required
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Partner ID"
								fullWidth={true}
								variant="standard"
								name="partnerId"
								value={partnerId || ""}
								// onChange={(e) => onInputChange(e)}
								onChange={(e) => onInputChange(e, "number")}
							></TextField> */}
							<TextField
								required
								margin="dense"
								variant="standard"

								select
								style={{ marginTop: "3px" }}

								color="primary"
								type="text"
								label="Owner ID"
								fullWidth
								name="partnerId"
								// value={walletOwnerId}
								defaultValue={partnerId || "Select Owner Id"}
								onChange={(e) => onInputChange(e)}

							>
								<MenuItem value="Select Owner Id" selected="Select Owner Id">
									Select Owner Id
								</MenuItem>
								{console.log("GETARRAYowner", getWalletOwnerIdResArray)}
								{getWalletOwnerIdResArray.status !== "failed" && getWalletOwnerIdRes.data.ownerList &&
									getWalletOwnerIdResArray.map((x) => (
										<MenuItem value={x.split("-")[0]}>{x}</MenuItem>
									))}
							</TextField>
							<TextField
								required
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="KYC Partner ID"
								fullWidth={true}
								variant="standard"

								name="kycPartnerId"
								value={kycPartnerId || ""}
								// onChange={(e) => onInputChange(e)}
								onChange={(e) => onInputChange(e, "number")}
							></TextField>
							<TextField
								required
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Username"
								fullWidth={true}
								variant="standard"

								name="username"
								defaultValue={username || ""}
								// onChange={(e) => onInputChange(e)}
								onChange={(e) => onInputChange(e, "alphabet")}
							></TextField>
							<TextField
								required
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								variant="standard"

								label="Key"
								fullWidth={true}
								name="key"
								value={key || ""}
								// onChange={(e) => onInputChange(e)}
								onChange={(e) => onInputChange(e, "both")}
							></TextField>
							<TextField
								required
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								variant="standard"

								label="Host URL"
								fullWidth={true}
								name="hostURL"
								defaultValue={hostURL || ""}
								onChange={(e) => onInputChange(e)}
							></TextField>
						</DialogContent>
						<DialogActions style={{ padding: "14px" }}>
							<CustomButton
								style={{
									// backgroundColor: "#fff",
									// color: "#000"
								}}
								variant="contained"
								onClick={handleClose}
							>
								Cancel
							</CustomButton>
							<CustomButton
								style={{
									// backgroundColor: "#00b9f5",
									// color: "white"
								}}
								variant="contained"
								onClick={addOrUpdateKycMappingReq}
							>
								Add
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			</Layout>

			{addOrUpdateKycMappingArray.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{addOrUpdateKycMappingArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{addOrUpdateKycMappingArray.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{addOrUpdateKycMappingArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
}

export default AdminKycMapping;
